/** @format */

import React from 'react';
import { PLAN_TYPES } from '../types';

interface PlanTypeSelectionProps {
  selectedPlanTypes: string[];
  isAcaRequest: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PlanTypeSelection: React.FC<PlanTypeSelectionProps> = ({
  selectedPlanTypes,
  isAcaRequest,
  onChange,
}) => {
  return (
    <div className='radial-input'>
      <label>Plan Type *</label>
      <div className='radial-input-wrapper'>
        {PLAN_TYPES.map((type) => (
          <label key={type}>
            <input
              type='checkbox'
              name='planType'
              value={type}
              checked={
                isAcaRequest && type === 'Major Medical'
                  ? true
                  : selectedPlanTypes?.includes(type) || false
              }
              onChange={(e) => {
                if (isAcaRequest && type === 'Major Medical') {
                  return;
                }
                onChange(e);
              }}
            />
            {type}
          </label>
        ))}
      </div>
    </div>
  );
};
